<template>
  <ul v-if="listItems" :class="[wrapperClass, openClose]">
    <li
        v-for="(item, index) in listItems"
        :key="index"
        :class="spanItemClass"
        @click="$emit('clickAction', item)">
      <span>{{item}}</span>
    </li>
  </ul>
</template>

<script>
  export default {
    props: {
      customItemClasses: String,
      customWrapperClasses: String,
      listItems: Array,
      openClose: String,
      separator: String,
    },

    name: 'ClickableList',

    data() {
      return {
        spanItemClass: 'clickable-list-item',
        wrapperClass: 'clickable-list-wrapper',
      }
    },

    created() {
      if (this.customItemClasses) { this.spanItemClass = this.customItemClasses }
      if (this.customWrapperClasses) { this.wrapperClass = this.customWrapperClasses }
    }
  }
</script>